/**
 * Marker for a Dutch phrase that stays verbatim across all locales in
 * course content (Leren). Used like:
 *
 *   { kind: "paragraph", text: ["Start your email with ", dutch("Geachte mevrouw/meneer,"), "."] }
 *
 * The renderer treats DutchPhrase specially (subtle visual mark) and the
 * translation pipeline never sends its `.text` to the translator.
 */
export interface DutchPhrase {
  readonly __kind: "dutch";
  readonly text: string;
}

export function dutch(text: string): DutchPhrase {
  return { __kind: "dutch", text };
}

export function isDutchPhrase(v: unknown): v is DutchPhrase {
  if (typeof v !== "object" || v === null) return false;
  return (v as { __kind?: unknown }).__kind === "dutch";
}
